import React from 'react';

import styles from './ExportPdfReportChartContainer.scss';

type Props = {
  dataTest?: string;
  chartSvg: string;
};

export const ExportPdfReportChartContainer: React.FC<Props> = ({ chartSvg, dataTest }) => {
  return (
    <div data-test={dataTest} className={styles.chartContainer}>
      <div dangerouslySetInnerHTML={{ __html: chartSvg }}></div>
    </div>
  );
};
